import { StoreBase } from './StoreBase';
import { StoreContext } from '../configuration/StoreContext';
import { action } from 'mobx';
import { IConfigurationComponentOrchestration } from '../models/app/IConfigurationComponentOrchestration';
import { query, utils } from '@kurtosys/ksys-app-template';
import { FundCardStore } from '../components/FundCard/stores/FundCardStore';
import { IExecutionOptions, IQueryOptions } from '../models/commonTypes';

export abstract class FundCardStoreBase extends StoreBase {
	fundCardStore: FundCardStore;

	constructor(storeContext: StoreContext, fundCardStore: FundCardStore) {
		super(storeContext);
		this.fundCardStore = fundCardStore;
	}


	@action
	async initialize(): Promise<void> {

	}

	getQueryValue(queryOptions?: IQueryOptions, responseForContext?: object, overrideExecutionOptions?: Partial<IExecutionOptions>) {
		if (queryOptions) {
			const responseContextExecutionOptions: Partial<IExecutionOptions> = {
				context: {
					response: responseForContext,
				},
			};
			overrideExecutionOptions = utils.object.deepMergeObjects(
				responseContextExecutionOptions,
				overrideExecutionOptions || {},
			);
			return this.fundCardStore.queryStore.query(queryOptions, overrideExecutionOptions);
		}
		return;
	}


	mergeQueriesAndProps<T>(componentOrchestration?: IConfigurationComponentOrchestration): T | undefined {
		if (componentOrchestration) {
			const { props, queries } = componentOrchestration;
			const queryResults = queries ? query.Query.convertQueryMime(queries, this.fundCardStore.queryStore.executionOptions) : {};
			const response: T = utils.object.deepMergeObjectsWithOptions({ arrayMergeStrategy: 'DeepMerge' }, props || {}, queryResults);
			return response;
		}
	}
}